import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class SessionService {
  private readonly SESSION_KEY = 'tms_session_id';
  private readonly ID_TOKEN_KEY = 'tms_id_token';

  constructor(private http: HttpClient) {}

  getSessionId(): string | null {
    return localStorage.getItem(this.SESSION_KEY);
  }

  isAuthenticated(): boolean {
    return this.getSessionId() !== null;
  }

  async logout(): Promise<void> {
    const sessionId = this.getSessionId();
    if (sessionId) {
      try {
        await firstValueFrom(
          this.http.post('/api/v2/logout', {}, {
            headers: {
              'Authorization': `Bearer ${sessionId}`
            }
          })
        );
      } catch (error) {
        console.error('Logout error:', error);
      }
      localStorage.removeItem(this.SESSION_KEY);
      localStorage.removeItem(this.ID_TOKEN_KEY);
    }
  }

  clearSession(): void {
    localStorage.removeItem(this.SESSION_KEY);
    localStorage.removeItem(this.ID_TOKEN_KEY);
  }

  saveSession(sessionId: string, idToken?: string): void {
    localStorage.setItem(this.SESSION_KEY, sessionId);
    if (idToken) {
      localStorage.setItem(this.ID_TOKEN_KEY, idToken);
    }
  }

  getIdToken(): string | null {
    return localStorage.getItem(this.ID_TOKEN_KEY);
  }

  setIdToken(idToken: string): void {
    localStorage.setItem(this.ID_TOKEN_KEY, idToken);
  }
}
